import { i18n } from '../../helper/i18n/index'

export default {
  render (h) {
    const children = []
    if (this.tabs && this.tabs.length) {
      children.push((
        <el-tabs
          value={this.activeTab}
          on-tab-click={this.onTabLinkSwitch}
        >
          {
            this.tabs.map(option => (
              <el-tab-pane
                label={i18n(option.label)}
                name={String(option.url)}
              />
            ))
          }
        </el-tabs>
      ))
    }
    return <div class='sp-tabs'>{children}</div>
  },
  props: {
    tabs: Array
  },
  methods: {
    onTabLinkSwitch(tab) {
      let url = this.tabs[tab.index].url
      this.$router.push(url)
    }
  },
  computed: {
    activeTab() {
      let activeTab;
      if (Array.isArray(this.tabs) && this.tabs.length) {
        for(let tab of this.tabs) {
          if (this.$route.path.includes(tab.url)) {
            activeTab = tab.url
            break
          }
        }
      }
      return activeTab
    }
  }
}


// WEBPACK FOOTER //
// ./packages/components/Tabs/index.js